// import axios from 'axios'
import {extranetApi, apiErrorCode, apiErrorMessage, resolvedApiFailure} from "../../services/Api";

export function loginUser(userObj) {
  // console.log('authActions::loginUser: returning LOGIN_USER object');
  return {
    type: 'LOGIN_USER',
    payload: userObj,
  }
}

export function logOutUser(userObj) {
  // console.log('authActions::logOutUser: returning LOGOUT_USER object');
  return {
    type: 'LOGOUT_USER',
    payload: userObj,
  }
}

export function fetchProfile(userObj) {
  // console.log('authActions::fetchProfile', userObj);
  return {
    type: 'FETCH_PROFILE',
    payload: userObj,
  }
}

export function fetchDashboard(dashboard) {
  // console.log('authActions::fetchDashboard', dashboard);
  return {
    type: 'FETCH_DASHBOARD',
    payload: dashboard,
  }
}

export const userLogOut = (dispatch) => {

  extranetApi.get('logout')
    .then((response) => {

      // console.log(response);
      if (response.status === 200) {

        if (response.data.success === true) {

          // console.log("API :: Logged out", response.data);
          dispatch(response.data.data);
          window.location.href = '/extranet/auth/signin';

        } else {

          console.log(response.data.message);
          // alert('Error: ' + response.data.message);

        }

      }
      else {
        // Unknown error
        console.log("Unknown server error");
        // alert("Unknown server error");
      }


    })
    .catch(function (error) {
      console.log(error);
      alert(error);
    });


}

export const getUserProfile = (dispatch) => {

  extranetApi.get('profile')
    .then((response) => {

      // console.log('FUCKING PROFILE RESPONSE: ', response);
      if (response.status === 200) {

        if (response.data.success === true) {

          // console.log("Got Profile", response.data);

          dispatch(response.data.data);

        } else {

          console.log(response.data.message);
          // alert('Error: ' + response.data.message);

        }

      }
      else {
        // Unknown error
        console.log("Unknown server error");
        // alert("Unknown server error");
      }


    })
    .catch(function (error) {
      console.log(error);
      alert(error);
    });

}

export const userLoginFetch = (user, dispatch) => {

  const ERROR_INVALID_LOGIN = 1021;

  // The API owns this copy and sends a deliberately generic message for 1021
  // (which now also covers disabled accounts), so display whatever it returns.
  // These two are only fallbacks for responses that carried no message at all.
  const INVALID_LOGIN_FALLBACK = 'Incorrect email address or password.';
  const GENERIC_FALLBACK = 'Unable to sign in right now. Please try again shortly.';

  let payload = {
    "login[username]": user.email,
    // "login[username]": user.username,
    "login[password]": user.password
  }
  // console.log('AuthActions::userLoginFetch', payload);

  const querystring = require('querystring');
  const headers = {
    'Content-Type': 'application/x-www-form-urlencoded'
  };

  return extranetApi.post('login', querystring.stringify(payload), { headers: headers })
    .then(function (response) {

      // console.log('userLoginFetch::Api post response', response);

      // NOTE: extranetApi's response interceptor returns HTTP errors into the
      // success chain as AxiosError objects (see services/Api.js), so a 4xx/5xx
      // lands here with its envelope in `response.response` - NOT in `.catch`.
      const failure = resolvedApiFailure(response);

      if (!failure && response.status === 200 && response.data.success === true) {

        const data = response.data.data;

        // Dispatching is left to the caller so it can tell a completed login
        // (full payload) apart from a pending MFA session (`mfa_required`).
        dispatch(data);

        return {mfaRequired: !!data.mfa_required, data: data};

      }

      if (failure) {

        const code = apiErrorCode(failure);

        if (code === ERROR_INVALID_LOGIN) {
          const message = apiErrorMessage(failure, INVALID_LOGIN_FALLBACK);
          dispatch({error: code, message: message});
          return {error: code, message: message};
        }

        // console.log('Login failed: ', failure);
        const message = apiErrorMessage(failure, GENERIC_FALLBACK);
        dispatch({error: code || 'unknown', message: message});
        return {error: code || 'unknown', message: message};

      }

      // 200 without the success envelope - shouldn't happen, but don't crash.
      const message = (response.data && response.data.message) || GENERIC_FALLBACK;
      dispatch({error: 'unknown', message: message});
      return {error: 'unknown', message: message};

    })
    .catch(function (error) {

      // Unreachable for HTTP errors (see NOTE above) - last resort for anything
      // thrown while handling the response itself.
      // console.log('Login failed: ', error);
      const message = apiErrorMessage(error, GENERIC_FALLBACK);
      dispatch({error: apiErrorCode(error) || 'unknown', message: message});
      return {error: apiErrorCode(error) || 'unknown', message: message};

    });

}

export const getProfileFetch = () => {
  // return dispatch => {
  return () => {

    console.log('Getting ping');
    extranetApi.get('ping')
      .then(function (response) {
        console.log(response);
      });

/*
    return fetch("http://localhost:3000/api/v1/profile", {
      method: "GET",
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'Authorization': `Bearer ${token}`
      }
    })
      .then(resp => resp.json())
      .then(data => {
        if (data.message) {
          // An error will occur if the token is invalid.
          // If this happens, you may want to remove the invalid token.
          localStorage.removeItem("token")
        } else {
          dispatch(loginUser(data.user))
        }
      })
*/

  }
}